import { render } from "./ASideProjectMainMenu.vue?vue&type=template&id=5fd46214"
import script from "./ASideProjectMainMenu.vue?vue&type=script&lang=js"
export * from "./ASideProjectMainMenu.vue?vue&type=script&lang=js"

import "./ASideProjectMainMenu.vue?vue&type=style&index=0&id=5fd46214&lang=scss"

import exportComponent from "/opt/app-root/src/main-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QIcon,QItemLabel});qInstall(script, 'directives', {Ripple});
